<template>
  <FullPageLayout class="relative">
    <template v-if="fetchState.pending">
      <div>loading...</div>
    </template>
    <template v-else-if="fetchState.error">
      <ErrorPageLayout :error="fetchState.error" />
    </template>
    <template v-else>
      <YazioBrands />
      <YazioHeader>
        <YazioInfo />
      </YazioHeader>
      <div class="sm:w-[1100px] w-full mx-auto px-4 sm:px-0">
        <YazioWidget icon="son-yazilar" title="Son Yazılar" class="sm:mt-9 mt-7">
          <ArticleSlider
            v-if="latestArticles.length"
            :articles="latestArticles"
            arrow-color="#9686c9"
            :data-layer="{ name: `Yazio Liste - Slider` }"
          >
            <SwiperSlide v-for="article in latestArticles" :key="article._id">
              <YazioSliderArticle class="yazio-slider-article" :item="article" :author="getAuthorFromArticle(article)" />
            </SwiperSlide>
          </ArticleSlider>
        </YazioWidget>
        <YazioWidget icon="yazarlar" title="Yazarlar" class="mt-16">
          <YazioTabs :authors="allAuthors" />
        </YazioWidget>
      </div>
    </template>
  </FullPageLayout>
</template>
<script>
import { defineComponent, useFetch, useContext, useMeta, ref, useRoute } from '@nuxtjs/composition-api';
import FullPageLayout from '@/modules/common/components/layout/FullPageLayout';
import ErrorPageLayout from '@/modules/common/components/layout/ErrorPageLayout.vue';
import YazioBrands from '@/modules/yazio/components/YazioBrands';
import YazioHeader from '@/modules/yazio/components/YazioHeader';
import YazioWidget from '@/modules/yazio/components/YazioWidget';
import YazioSliderArticle from '@/modules/yazio/components/YazioSliderArticle';
import YazioTabs from '@/modules/yazio/components/YazioTabs';
import YazioInfo from '@/modules/yazio/components/YazioInfo';
import SwiperSlide from '@/modules/sliders/core/SwiperSlide';
import ArticleSlider from '~/modules/sliders/components/common/ArticleSlider';
import { HOST_URL, IS_ONEDIO } from '~/constants/config';

export default defineComponent({
  components: {
    FullPageLayout,
    ErrorPageLayout,
    YazioBrands,
    YazioHeader,
    YazioWidget,
    YazioSliderArticle,
    YazioTabs,
    YazioInfo,
    ArticleSlider,
    SwiperSlide,
  },
  head: {},
  setup() {
    const { $error, $service, $cache } = useContext();
    const latestArticles = ref([]);
    const allAuthors = ref([]);
    const route = useRoute();
    const path = route.value.path;
    $cache('public, max-age=30');
    useMeta({
      title: 'Onedio Köşe Yazarları Yazio',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            "Farklı sektörlerden gelen ve farklı bakış açılarına sahip yazarları buluşturduğumuz Yazio'daki birbirinden özel içerikleri incelemek için hemen tıklayın!",
        },
      ],
      bodyAttrs: { class: 'yazio-background' },
      link: [{ hid: 'canonical', rel: 'canonical', href: HOST_URL + path }],
    });
    const { fetch, fetchState } = useFetch(async () => {
      try {
        if (!IS_ONEDIO) {
          $error('Page not found', 404, false);
        }
        const [{ data }, { data: allAuthorsData }] = await Promise.all([
          $service.yazio.getLatestYazioArticles(),
          $service.yazio.getAllYazioAuthors(),
        ]);
        latestArticles.value = data;
        allAuthors.value = allAuthorsData;
      } catch (error) {
        $error(error);
      }
    });
    const getAuthorFromArticle = (article) => {
      return allAuthors.value.find((author) => article.author?._id === author?._id);
    };
    return { fetch, fetchState, latestArticles, getAuthorFromArticle, allAuthors };
  },
});
</script>
<style lang="scss">
.yazio-background {
  background: #f7f8fb;
}

.yazio-slider-article {
  height: 305px;
  width: 300px;
}
@media (min-width: 640px) {
  .yazio-slider-article {
    height: 280px;
    width: auto;
  }
}
@media (max-width: 348px) {
  .yazio-slider-article {
    width: 260px;
  }
}
</style>
